/**
 * Funnel stage palette — chromatic hex for Recharts/SVG (aligned with adminChartSeries).
 */
import { ADMIN_CHART_SERIES_HEX } from '../../../shared/ui/adminChartSeries.js';

export const FUNNEL_STAGE_COLORS: readonly string[] = [
  ADMIN_CHART_SERIES_HEX[4], // purple
  ADMIN_CHART_SERIES_HEX[0], // blue
  ADMIN_CHART_SERIES_HEX[1], // teal
  ADMIN_CHART_SERIES_HEX[2], // amber
  '#059669', // green
  ADMIN_CHART_SERIES_HEX[5], // cyan
] as const;

export function funnelStageColor(index: number): string {
  return (
    FUNNEL_STAGE_COLORS[index % FUNNEL_STAGE_COLORS.length]
    ?? ADMIN_CHART_SERIES_HEX[0]
  );
}
